import ProductCard from "./product_card";
import { StyleSheet, css } from "aphrodite";

export default function ProductCardContainer({products}){
    const onClickProduct= (url)=>{
        window.location.href=url
    }
    
    const styles = StyleSheet.create({
        mainContainer: {
            backgroundColor: '#F0EFEC',
            display: 'flex',
            justifyContent: ' center',
            alignItems: 'center',
            flexDirection:'column'
        },
        productTitleStyle: {
            color: '#011a39',
            fontFamily: 'Oswald',
            fontStyle: "bold",
            fontSize: "3rem",
            textAlign: "center",
            width: '80%'
        },
        productsCardContainerStyle: {
            display: 'flex',
            justifyContent: ' space-evenly',
            alignItems: 'center',
            width:"80%",
            padding:'50px',
            flexDirection: 'column',
            gap: '10px',
            flexWrap: 'wrap',
            "@media (min-width: 1024px)": {
                flexDirection: 'row',
            }
        }
    })
    return(
        <>
            <div className={css(styles.mainContainer)}>
                <div className={css(styles.productTitleStyle)}>Products:</div>
                <div className={css(styles.productsCardContainerStyle)}>
                    {
                         Object.values(products).map((prod)=>{
                            return <ProductCard
                                key={prod.uid} 
                                img={prod.mainImage} 
                                title={prod.title}
                                url={prod.url}
                            />
                        })
                    }
                </div>
            </div>
        </>
    )
}